// datalayer.js
export class GADataLayerHelper {
    constructor() {
        // Initialize data layer if it doesn't exist
        window.dataLayer = window.dataLayer || [];
    }

    /**
     * Push an event to the data layer
     * @param {string} eventName - Name of the event
     * @param {Object} [eventData={}] - Additional event data
     * @throws {Error} If eventName is not provided or not a string
     */
    push(eventName, eventData = {}) {
        if (!eventName || typeof eventName !== 'string') {
            throw new Error('Event name must be a non-empty string');
        }

        const payload = {
            event: eventName,
            timestamp: new Date().toISOString(),
            ...eventData
        };

        window.dataLayer.push(payload);
    }

    /**
     * Push an e-commerce event to the data layer
     * @param {string} eventName - Name of the event
     * @param {Object} ecommerceData - E-commerce specific data
     */
    pushEcommerce(eventName, ecommerceData) {
        // Clear previous ecommerce object to prevent data mixing
        window.dataLayer.push({ ecommerce: null });

        this.push(eventName, {
            ecommerce: ecommerceData
        });
    }
}

// Create a singleton instance
window.gaDataLayerHelper = new GADataLayerHelper();

// Also export for ES module usage
export const gaDataLayerHelper = window.gaDataLayerHelper;